<div class="flex between-spacer">
  <h3 class="titulo">Salidas</h3>
  <button class="btn-volver" routerLink="/venta/opciones/menu">volver</button>
</div>

<div class="productos-content">
  <button
    *ngFor="let proveedor of proveedores | async"
    class="btn-producto"
    (click)="cuadroProveedor(proveedor)"
  >
    <div class="flex column-direction around-spacer">
      <span>{{ proveedor.nombre }}</span>
    </div>
  </button>
</div>

<!-- Modal Opciones Productos-->
<div
  class="modal fade"
  id="modalEgresos"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modelTitleId"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-producto-contenido">
        <h2 class="nombre-producto">
          {{ provForm.controls.proveedor.value.nombre }}
        </h2>

        <form [formGroup]="provForm" class="flex center-center mb-1">
          <input
            class="input-producto-qty"
            type="text"
            formControlName="monto"
          />
        </form>

        <div class="row-numeros">
          <button class="btn-numero" (click)="agregarDigito('7')">7</button>
          <button class="btn-numero" (click)="agregarDigito('8')">8</button>
          <button class="btn-numero" (click)="agregarDigito('9')">9</button>
        </div>

        <div class="row-numeros">
          <button class="btn-numero" (click)="agregarDigito('4')">4</button>
          <button class="btn-numero" (click)="agregarDigito('5')">5</button>
          <button class="btn-numero" (click)="agregarDigito('6')">6</button>
        </div>

        <div class="row-numeros">
          <button class="btn-numero" (click)="agregarDigito('1')">1</button>
          <button class="btn-numero" (click)="agregarDigito('2')">2</button>
          <button class="btn-numero" (click)="agregarDigito('3')">3</button>
        </div>

        <div class="row-numeros">
          <button class="btn-numero" (click)="agregarDigito('0')">0</button>
          <button class="btn-numero" (click)="agregarDigito('00')">00</button>
          <button class="btn-numero" (click)="borrarDigito()">
            <i class="fas fa-backspace"></i>
          </button>
        </div>

        <div class="seccion-botones">
          <button class="btn-aceptar" (click)="guardarEgreso()">ACEPTAR</button>
          <button class="btn-eliminar" data-dismiss="modal">CANCELAR</button>
        </div>
      </div>
    </div>
  </div>
</div>
